import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClients, setClient } from "../../../../slices/clientesSlice";
import ClienteModal from "../../../../components/modales/Cliente/ClienteModal";
import ModalDeleteClient from "../../../../components/modales/Cliente/DeleteModal";
import ModalEditCliente from "../../../../components/modales/Cliente/EditModal";
import { message } from "antd";
import { filterByName, getPodcasts, getProspects, setPodcast, sortPlanActive, sortPodcastsName } from "../../../../slices/podcastSlice";
import { ChevronFirst, ChevronLast, ChevronLeft, ChevronRight, Eye, Pencil, Trash } from "lucide-react";
import { sortNewIdea } from "../../../../slices/prospectSlice";
import PodcastModal from "../../../../components/modales/podcast/PodcastModal";
import PodcastDelete from "../../../../components/modales/podcast/PodcastDelete";
import PodcastEdit from "../../../../components/modales/podcast/PodcastEdit";
import { useNavigate } from "react-router-dom";

export default function Podcasts() {
  const dispatch = useDispatch();
  

  const { podcasts } = useSelector((state) => state.podcast);
  const { isDarkMode } = useSelector((state) => state.darkMode);

  //* Estados para modales
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [name, setName] = useState("");

  //* Paginacion
    const [currentPage, setCurrentPage] = useState(1)
    const podcastForPage = 8;
    const startIndex = (currentPage - 1) * podcastForPage;
    const endIndex = startIndex + podcastForPage;
    const podcastPaginates = podcasts.slice(startIndex, endIndex)
    const totalPages = Math.ceil(podcasts.length / podcastForPage);
  
    const handlePrevPage = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };
  
    const handleNextPage = () => {
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      }
    };
  
  //* Estados sorts
  const [order, setOrder] = useState("");
  const [orderActives, setOrderActives] = useState("")
  const [orderNew, setOrderNew] = useState("")

  //? Alertas
  const [messageApi, contextHolder] = message.useMessage();

  const successEditClient = () => {
    messageApi.open({
      type: "success",
      content: "Cliente actualizado correctamente!",
    });
  };
  const errorEditClient = () => {
    messageApi.open({
      type: "error",
      content: "Error al actualizar el cliente",
    });
  };

  const handleViewModal = (podcast) => {
    dispatch(setPodcast(podcast));
    setIsModalOpen(true);
  };

  const handleDeleteModal = (podcast) => {
    dispatch(setPodcast(podcast));
    setIsDeleteModal(true);
  };

  const handleEditModal = (podcast) => {
    dispatch(setPodcast(podcast));
    setIsEditModal(true);
  };

  const handleEditToView = () => {
    setIsModalOpen(false);
    setIsEditModal(true);
  };

  const handlerOrderName = () => {
      let newOrder = "";
      if (order === "") {
        newOrder = "asc";
      } else if (order === "asc") {
        newOrder = "desc";
      } else if (order === "desc") {
        newOrder = "";
      }
      setOrder(newOrder);
      dispatch(sortPodcastsName(newOrder));
      // setCurrenPage(1);
    };

    const handlerOrderNew = () => {
      let newOrder = "";
      if (orderNew === "") {
        newOrder = "asc";
      } else if (orderNew === "asc") {
        newOrder = "desc";
      } else if (orderNew === "desc") {
        newOrder = "";
      }
      setOrderNew(newOrder);
      dispatch(sortNewIdea(newOrder));
      // setCurrenPage(1);
    };

    const handlerOrderActive = () => {
      let newOrder = "";
      if (orderActives === "") {
        newOrder = "asc";
      } else if (orderActives === "asc") {
        newOrder = "desc";
      } else if (orderActives === "desc") {
        newOrder = "";
      }
      setOrderActives(newOrder);
      dispatch(sortPlanActive(newOrder));
      // setCurrenPage(1);
    };

    const handleFilterByName = (e) => {
      const name = e.target.value;
      setName(name)
      dispatch(filterByName(name))
    }

    const colors = ["bg-blue-600", "bg-purple-600", "bg-red-600", "bg-yellow-500", "bg-green-500"];

    const getInitials = (name) => {
      return name?.split(" ").map((word) => word.charAt(0).toUpperCase()).join("");
    };

  useEffect(() => {
    dispatch(getPodcasts());
  }, [dispatch]);

  return (
    <div className="sm:p-6 p-0 bg-background min-h-screen">
      {contextHolder}

      <PodcastModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleEditToView={handleEditToView}
      />
      <PodcastDelete
        isDeleteModal={isDeleteModal}
        setIsDeleteModal={setIsDeleteModal}
      />
      <PodcastEdit
        isEditModal={isEditModal}
        setIsEditModal={setIsEditModal}
        successEditClient={successEditClient}
      />

      <section className="container mx-auto sm:p-6 p-0 font-poppina">
        <div className="w-full mb-8 overflow-hidden  shadow-sm">

        <div className="flex justify-end mb-3">
            <input
              className="bg-background text-text w-[220px] rounded"
              type="text"
              value={name}
              onChange={handleFilterByName}
              placeholder="Buscar por nombre"
            />
          </div>

          <div className="w-full rounded-lg overflow-hidden border border-border overflow-x-auto">
            <table className="w-full rounded-lg text-sm bg-background text-gray-700  ">
              <thead className="bg-background">
                <tr className="text-left">
                  <th onClick={handlerOrderName} className="p-2 sm:p-4 cursor-pointer items-center gap-1 text-subtitle">
                    Nombre
                    <span className="text-sm ml-2">
                      {order === "asc" && "▲"}
                      {order === "desc" && "▼"}
                      {order === "" && "↕"}
                    </span>
                  </th>
                  <th className="p-2 sm:p-4 hidden md:table-cell text-subtitle">
                    Descripcion
                  </th>
                  <th onClick={handlerOrderNew} className="p-2 sm:p-4 cursor-pointer hidden md:table-cell text-subtitle">
                    Es nueva idea?
                    <span className="text-sm ml-2">
                      {orderNew === "asc" && "▲"}
                      {orderNew === "desc" && "▼"}
                      {orderNew === "" && "↕"}
                    </span>
                  </th>
                  <th onClick={handlerOrderActive} className="p-2 cursor-pointer sm:p-4 hidden md:table-cell text-subtitle">
                    Activo
                    <span className="text-sm ml-2 ">
                      {orderActives === "asc" && "▲"}
                      {orderActives === "desc" && "▼"}
                      {orderActives === "" && "↕"}
                    </span>
                  </th>
                  <th className="p-2 sm:p-4 text-center text-subtitle">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {podcasts.length > 0 ? (
                  podcasts.map((podcast, index) => (
                    <tr
                      key={index}
                      className={`transition-colors ${
                        isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                      }`}
                    >
                      <td
                        className="p-2 sm:p-4 text-text flex items-center gap-3"
                        style={{
                          maxWidth: "120px",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                      <p className={`bg-blue-500 text-white p-2 rounded ${
                  colors[index % colors.length] 
                } `}>{getInitials(podcast.name)} </p>
                        <p>{podcast.name} </p>
                      </td>
                      <td
                        className="p-2 sm:p-4 text-text hidden md:table-cell"
                        style={{
                          maxWidth: "120px",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        <p>{podcast.description} </p>
                      </td>
                      <td
                        className="p-2 sm:p-4 text-text hidden md:table-cell"
                        style={{
                          maxWidth: "120px",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        <p>{podcast.newIdea === true ? "Si" : "No" } </p>
                      </td>
                      <td
                        className="p-2 sm:p-4 text-text hidden md:table-cell"
                        style={{
                          maxWidth: "120px",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        <p>{podcast.planActive === true ? "Si" : "No" } </p>
                      </td>
                      <td className="p-2 sm:p-4">
                        <div className="flex justify-center gap-2">
                          <button
                            onClick={() => handleViewModal(podcast) }
                            className="p-1.5 sm:p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition"
                          >
                            <Eye className="w-4 h-4 sm:w-5 sm:h-5" />
                          </button>
                          

                          <button
                            onClick={() => {handleDeleteModal(podcast)}}
                            className="p-1.5 sm:p-2 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-lg transition"
                          >
                            <Trash className="w-4 h-4 sm:w-5 sm:h-5" />
                          </button>
                          
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="p-4 text-center text-gray-500">
                      No hay clientes disponibles.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            
          </div>
          <div className="flex justify-center items-center gap-4 mt-6">
              <button
                onClick={() => setCurrentPage(1)}
                className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
                  currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
                }`}
                disabled={currentPage === 1}
              >
                <ChevronFirst className="w-5 h-5 text-text" />
              </button>

              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
                  currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
                }`}
              >
                <ChevronLeft className="w-5 h-5 text-text" />
              </button>
              <span className="text-sm text-text">
                Página {currentPage} de {totalPages}
              </span>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
                  currentPage === totalPages
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
              >
                <ChevronRight className="w-5 h-5 text-text" />
              </button>

              <button
                onClick={() => setCurrentPage(totalPages)}
                className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
                  currentPage === totalPages
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
                disabled={currentPage === totalPages}
              >
                <ChevronLast className="w-5 h-5 text-text " />
              </button>
            </div>
        </div>
      </section>
    </div>
  );
}
